import React from "react";
import { Layout } from "../../nq-component";
import NavBar2 from "../NavBar2";

function NavBar({ ...props }) {
  const { collapsed, setCollapse } = React.useContext(Layout.Context);

  function onClickNavigate() {
    setCollapse(!collapsed);
  }

  return (
    <NavBar2
      className="bg-white border border-bottom border-1 opacity-100"
      logo="/logo.svg"
      //   title="DASHBOARD"
      onClickNavigate={onClickNavigate}
      user={props.user}
      {...props}
    />
  );
}

export default NavBar;
